import TaskInfo from './TaskInfo.vue'

export default TaskInfo